/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsElements {
  /**
   * Is a NodeList or HTMLCollection so you can iterate
   *
   * @public
   * @function f1.is.elements
   * @example
   *
   * ```ts
   * // HTMLCollection
   * f1.is.elements(document.getElementsByClassName('marker')) => true
   * // NodeList
   * f1.is.elements(document.querySelectorAll('.marker')) => true
   * ```
   */
  (value: Object): value is NodeList | HTMLCollection;
}

/**
 * @see IsElements
 */
export default (value: Object): value is NodeList | HTMLCollection => {
  return NodeList.prototype.isPrototypeOf(value) || HTMLCollection.prototype.isPrototypeOf(value);
};
